import React, { useState } from 'react';
import styled from 'styled-components';
import CompanyInfoModal from './CompanyInfoModal';

const Footer = ({ showDisclaimer = false, style, className }) => {
  const [showCompanyInfo, setShowCompanyInfo] = useState(false);

  return (
    <FooterContainer style={style} className={className}>
      <FooterContent>
        <FooterMain>
          <FooterSection>
            <FooterBrand>
              <BrandIcon src="/images/logos/logo.svg" alt="职唛 AI Logo" />
              <FooterBrandText>职唛 AI</FooterBrandText>
            </FooterBrand>
            <FooterDescription>
              通过AI驱动的面试准备提升你的信心，助你在求职面试中脱颖而出。
            </FooterDescription>
            {showDisclaimer && (
              <CompanyDisclaimer>
                本网站展示的公司标识仅用于展示目的，不代表与相关公司存在任何合作关系。所有商标归其各自所有者所有。
              </CompanyDisclaimer>
            )}
          </FooterSection>

          <FooterSection>
            <FooterSectionTitle>产品服务</FooterSectionTitle>
            <FooterLinkList>
              <FooterLink>模拟面试</FooterLink>
              <FooterLink>简历诊断</FooterLink>
              <FooterLink>面试押题</FooterLink>
            </FooterLinkList>
          </FooterSection>

          <FooterSection>
            <FooterSectionTitle>关于我们</FooterSectionTitle>
            <FooterLinkList>
              <FooterLink onClick={() => setShowCompanyInfo(true)}>公司介绍</FooterLink>
              <FooterLink>
                <FooterLinkAnchor href="/privacy">隐私协议</FooterLinkAnchor>
              </FooterLink>
              <FooterLink>
                <FooterLinkAnchor href="/terms">用户服务协议</FooterLinkAnchor>
              </FooterLink>
            </FooterLinkList>
          </FooterSection>

          <FooterSection>
            <FooterSectionTitle>商务合作</FooterSectionTitle>
            <ContactInfo>
              <ContactLine>邮箱：bd@zhispark.com</ContactLine>
              <ContactLine>地址：浙江省杭州市萧山区德必港立WE产业园A座315室</ContactLine>
            </ContactInfo>
          </FooterSection>
        </FooterMain>

        <FooterDivider />

        <FooterBottom>
          <FooterBottomCenter>
            <CopyrightText>
              © 2026 杭州元烁智创科技有限公司 版权所有 | <BeianLink href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">浙ICP备2026002246号</BeianLink> | 浙公网安备 xxx号
            </CopyrightText>
          </FooterBottomCenter>
        </FooterBottom>
      </FooterContent>
      <CompanyInfoModal isOpen={showCompanyInfo} onClose={() => setShowCompanyInfo(false)} />
    </FooterContainer>
  );
};

// Styled Components
const FooterContainer = styled.footer`
  background: #1a1a1a;
  color: white;
  padding: 1.5rem 2rem 0.8rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 1920px) {
    max-width: 1500px;
  }

  @media (min-width: 2560px) {
    max-width: 1700px;
  }
`;

const FooterMain = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const FooterSection = styled.div`
  text-align: left;
  
  &:first-child {
    flex: 1.5;
  }
  
  &:not(:first-child) {
    flex: 0.8;
  }
`;

const FooterSectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.4rem;
  color: white;
`;

const FooterLinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLink = styled.li`
  margin-bottom: 0.2rem;
  color: #9CA3AF;
  font-size: 0.8rem;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
  }
`;

const FooterLinkAnchor = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
  }
`;

const ContactInfo = styled.div`
  margin-top: 0;
`;

const ContactLine = styled.p`
  margin: 0.1rem 0;
  font-size: 0.8rem;
  color: #9CA3AF;
`;

const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 0.8rem 0 0.6rem;
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterBottomCenter = styled.div`
  text-align: center;
`;

const CopyrightText = styled.p`
  color: #9CA3AF;
  font-size: 0.8rem;
`;

const BeianLink = styled.a`
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }
`;

const FooterBrand = styled.h3`
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const FooterBrandText = styled.span`
  color: white;
`;

const FooterDescription = styled.p`
  color: #9CA3AF;
  margin-bottom: 0;
  line-height: 1.3;
  font-size: 0.85rem;
`;

const BrandIcon = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 8px;
  transition: all 0.2s ease;
`;

const CompanyDisclaimer = styled.p`
  margin-top: 1rem;
  padding: 0;
  font-size: 0.7rem;
  color: #9CA3AF;
  text-align: left;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 0.65rem;
    margin-top: 0.8rem;
    text-align: center;
  }
`;

export default Footer;
